import { WatchAPI } from 'lib/api';
import appSelector from 'common/selectors/appSelector';

export function getListingsByType(type, query) {
    return async (dispatch, getState) => {
        const listings = await WatchAPI.getListings({ ...query, types: [type] });
        const { lang } = appSelector(getState());
        const { league } = query;
        // inherited from the legacy logic
        const hasLeague = league && league !== 'tennis' && league !== 'golf';
        const filtered = hasLeague ? listings.filter(listing => listing.subcategories
            .filter(({ name, shortName, abbreviation, id }) => (
                league === name ||
                league === shortName ||
                league === abbreviation ||
                league === id
            )).length > 0) : listings;
        return WatchAPI.getPrioritizedEventFromListings(filtered, lang);
    };
}

export function getListingsBySubcategory(type, query) {
    return async () => {
        const listings = await WatchAPI.getListingsBySubcategory({ ...query, types: [type] });
        return listings;
    };
}

export function getEventByQuery(query = {}) {
    return async (dispatch) => {
        const { partner, dates } = query;
        let liveData;
        let upcomingData;
        let replayData;

        if (partner) {
            const newQuery = { subcategory: partner, networks: ['espn3'], dates };
            liveData = dispatch(getListingsBySubcategory('live', newQuery));
            upcomingData = dispatch(getListingsBySubcategory('upcoming', newQuery));
            replayData = dispatch(getListingsBySubcategory('replay', newQuery));
            [liveData, upcomingData, replayData] = [await liveData, await upcomingData, await replayData];
            return (liveData && liveData[0]) || (upcomingData && upcomingData[0]) || (replayData && replayData[0]);
        }

        liveData = dispatch(getListingsByType('live', query));
        upcomingData = dispatch(getListingsByType('upcoming', query));
        replayData = dispatch(getListingsByType('replay', query));
        [liveData, upcomingData, replayData] = [await liveData, await upcomingData, await replayData];
        return liveData || replayData || upcomingData;
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/listingsActions.js